const PriceRange = ({ open, low, high, close, lastPrice }) => {
    const percentage = ((lastPrice - low) / (high - low)) * 100;

    return (
        <div className="price-range">
            <div>
                <span>Open {open}</span>
                <span>Prev. Close {close}</span>
            </div>
            <div>
                <span>Low {low}</span>
                <div className="range-bar">
                    <div className="range-fill" style={{ width: `${percentage}%` }}></div>
                </div>
                <span>High {high}</span>
            </div>
        </div>
    );
};

export default PriceRange;
